import type { ReactElement, SVGProps } from "react";

export type IconName =
  | "truck"
  | "quality"
  | "design"
  | "custom"
  | "signs"
  | "rollups"
  | "stickers"
  | "events"
  | "business"
  | "gifts"
  | "search"
  | "menu"
  | "close"
  | "cart"
  | "whatsapp"
  | "chevron-down"
  | "check"
  | "mail"
  | "pick"
  | "size"
  | "upload"
  | "approve"
  | "receive"
  | "service"
  | "clock"
  | "account"
  | "tracking";

const PATHS: Record<IconName, ReactElement> = {
  truck: (
    <>
      <path d="M2 8h11v9H2z" />
      <path d="M13 11h4l3 3v3h-7z" />
      <circle cx="6" cy="19" r="1.6" />
      <circle cx="17" cy="19" r="1.6" />
    </>
  ),
  quality: (
    <>
      <path d="M12 3l2.5 5.2L20 9l-4 4 1 5.6L12 16l-5 2.6 1-5.6-4-4 5.5-.8z" />
    </>
  ),
  design: (
    <>
      <path d="M4 20l4.2-1.1L18.5 8.6a2 2 0 0 0 0-2.8l-.3-.3a2 2 0 0 0-2.8 0L5.1 15.8 4 20z" />
      <path d="M13.5 6.5l3 3" />
    </>
  ),
  custom: (
    <>
      <path d="M4 6h9M17 6h3M4 12h3M9 12h11M4 18h13M19 18h1" />
      <circle cx="15" cy="6" r="2" />
      <circle cx="7" cy="12" r="2" />
      <circle cx="17" cy="18" r="2" />
    </>
  ),
  signs: (
    <>
      <rect x="4" y="5" width="16" height="10" rx="1.5" />
      <path d="M9 15v4M15 15v4M7 22h10" />
    </>
  ),
  rollups: (
    <>
      <rect x="7" y="3" width="10" height="16" rx="1.2" />
      <path d="M12 19v2M9 22h6" />
    </>
  ),
  stickers: (
    <>
      <path d="M14 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h7l6-6V7a3 3 0 0 0-3-3z" />
      <path d="M14 20v-4a2 2 0 0 1 2-2h4" />
    </>
  ),
  events: (
    <>
      <path d="M12 3s4 3.6 4 7a4 4 0 0 1-8 0c0-3.4 4-7 4-7z" />
      <path d="M6 21c0-3 2.7-5 6-5s6 2 6 5" />
    </>
  ),
  business: (
    <>
      <rect x="3" y="9" width="18" height="12" rx="1.2" />
      <path d="M8 9V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v3" />
      <path d="M3 14h18" />
    </>
  ),
  gifts: (
    <>
      <rect x="4" y="9" width="16" height="11" rx="1.2" />
      <path d="M4 13h16M12 9v11" />
      <path d="M12 9c-1.8 0-3.4-1.2-3.4-3S9 3 10.5 3 12 5 12 5s0-2 1.5-2S15.4 4.2 15.4 6 13.8 9 12 9z" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M20 20l-4.8-4.8" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  cart: (
    <>
      <circle cx="9" cy="20" r="1.5" />
      <circle cx="18" cy="20" r="1.5" />
      <path d="M2.5 3h2.4L7 14.5h10.8L20.5 6H6.2" />
    </>
  ),
  whatsapp: (
    <path d="M12 3a9 9 0 0 0-7.7 13.6L3 21l4.5-1.2A9 9 0 1 0 12 3zm4.9 12.6c-.2.6-1.2 1.1-1.7 1.2-.4.1-1 .1-1.6-.1-.4-.1-.9-.3-1.5-.6-2.6-1.1-4.3-3.8-4.5-4-.1-.2-1-1.4-1-2.6s.6-1.8.9-2c.2-.2.5-.3.7-.3h.5c.2 0 .4 0 .6.4.2.5.7 1.8.8 1.9.1.2.1.3 0 .5-.1.2-.1.3-.3.5-.1.2-.3.4-.4.5-.2.2-.3.4-.1.7.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.4 2.5 1.6.3.1.4.1.6-.1.2-.2.7-.8.9-1 .2-.3.4-.2.6-.1l1.7.8c.2.1.4.2.4.3.1.2.1.7-.1 1.3z" />
  ),
  mail: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M4 7l8 6 8-6" />
    </>
  ),
  "chevron-down": <path d="M6 9l6 6 6-6" />,
  check: <path d="M5 13l4 4L19 7" />,
  pick: (
    <>
      <path d="M4 20l4.2-1.1L18.5 8.6a2 2 0 0 0 0-2.8l-.3-.3a2 2 0 0 0-2.8 0L5.1 15.8 4 20z" />
      <path d="M13.5 6.5l3 3" />
    </>
  ),
  size: (
    <>
      <path d="M4 4h16v16H4z" />
      <path d="M4 9h5M4 14h3M9 4v5M14 4v3" />
    </>
  ),
  upload: (
    <>
      <path d="M12 16V5M8 9l4-4 4 4" />
      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
    </>
  ),
  approve: (
    <>
      <path d="M9 12l2 2 4-4" />
      <circle cx="12" cy="12" r="9" />
    </>
  ),
  receive: (
    <>
      <path d="M3 9l9-5 9 5-9 5-9-5z" />
      <path d="M3 9v6l9 5 9-5V9M12 14v6" />
    </>
  ),
  service: (
    <>
      <path d="M4 13a8 8 0 0 1 16 0" />
      <rect x="2.5" y="13" width="5" height="7" rx="2" />
      <rect x="16.5" y="13" width="5" height="7" rx="2" />
      <path d="M20 20a4 4 0 0 1-4 4h-2" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </>
  ),
  account: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4.4 3.6-7 8-7s8 2.6 8 7" />
    </>
  ),
  tracking: (
    <>
      <path d="M6 3h9l3 3v15H6z" />
      <path d="M9 9h6M9 13h6M9 17h3" />
    </>
  ),
};

export function Icon({
  name,
  size = 22,
  ...rest
}: { name: IconName; size?: number } & SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {PATHS[name]}
    </svg>
  );
}
